import React, {useRef,useState} from 'react'
import SocialFasho from '../../assets/Images/fashionBG.svg';
import userService from '../../services/userapi';
import {getAccessToken} from '../../services/accessToken'
import {getSpecificUrl} from '../../helpers/helperUrl'
import { useSelector } from 'react-redux';

const ProfilePicture = ({user}) => {
    

    // const user = useSelector(state => state.userSelectReducer.user)
   
    
    const useProfilePictureImg = () => {
        if((user !=null) && (user["profilepicture"] != undefined)) {
            //console.log("We got the profile pic", user.profilepicture)
            //console.log("We got the profile pic", user.id)
            return `https://polar-castle-07148.herokuapp.com/api/user/images/profileavatars/${user.id}/${user.profilepicture}`
        }
        else{
            return `https://polar-castle-07148.herokuapp.com/api/user/images/profileavatars/noprofile/profilepicture.jpg`
        }
    }

    const inputRef = useRef()
    const [profileImage, setProfileImage] = useState(useProfilePictureImg())
    const [token, setToken] = useState()
    
    const imageClicked = () => {
        console.log("Image upload")
        inputRef.current.click()

    }

    const imageOnChange = (e) => {
        const token = getAccessToken()
        console.log("on change image", e.target.files[0])
        userService.uploadUserAvatar(token,e.target.files[0]).then(x => {
            console.log("DONE FROM CLIENT", x.data.imagePath)
            setProfileImage(`https://polar-castle-07148.herokuapp.com/api/user/images/profileavatars/${user.id}/${x.data.profilepicture}`)
            sessionStorage.setItem('user', JSON.stringify(x.data));
        })
        // console.log("on change image", e.target.files[0])

    }

    return (
        <>
            <img className="rounded-full h-40 w-40 cursor-pointer object-cover border-white border-2" onClick={imageClicked}  src={profileImage}/>
            <input ref={inputRef} type="file" className="rounded-full  hidden" id="profileUpload" name="profileimage" accept="image/*" onChange={(evt) => imageOnChange(evt)}/>
        </>
    )
}

export default ProfilePicture